import PropTypes from "prop-types";

import { FlexContainers, SVG, ViewOnlyInputValues, WrapperContainer } from "../../components";
import {
  ComponentWrapper,
  IconWrapper,
  SearchIconWrapper,
  SearchInputWrapper,
  ComponentContentWrapper
} from "./styled";
import { InputContainer, InputTitleWrapper } from "../Input/styled";

const SearchInput = ({
  id,
  title,
  warningMsg,
  value,
  setValue,
  placeholder,
  showSearchIcon = true,
  hasError,
  disabled,
  onSearchIconClick = () => {},
  icon,
  component,
  viewOnly,
  disableSearch,
  maxLength,
  innerRef
}) => {
  return (
    <InputContainer
      data-testid="input-container"
      className={hasError && "error"}
      disabled={disabled}
      ref={innerRef}>
      <WrapperContainer Container={FlexContainers.FlexRowBetween} width="100%">
        {title && (
          <InputTitleWrapper>
            <label htmlFor={id}>{title}</label>
          </InputTitleWrapper>
        )}

        {warningMsg && (
          <InputTitleWrapper>
            <WrapperContainer Container={FlexContainers.FlexRowEnd} width="100%">
              <p>{warningMsg}</p>
            </WrapperContainer>
          </InputTitleWrapper>
        )}
      </WrapperContainer>

      {viewOnly ? (
        <ViewOnlyInputValues value={value} placeholder={placeholder} />
      ) : (
        <>
          <SearchInputWrapper
            value={value}
            icon={icon}
            showSearchIcon={showSearchIcon}
            disableSearch={disableSearch}>
            <SearchIconWrapper visible={showSearchIcon} onClick={onSearchIconClick}>
              <SVG.SearchIcon />
            </SearchIconWrapper>

            {component ? (
              <ComponentWrapper showSearchIcon={showSearchIcon}>
                <ComponentContentWrapper visible={component}>{component}</ComponentContentWrapper>
              </ComponentWrapper>
            ) : (
              <input
                id={id}
                data-testid="search-input"
                type={"text"}
                value={value ? value : ""}
                placeholder={placeholder}
                onChange={(e) => {
                  if (maxLength > 0) {
                    e.target.value.length <= maxLength && setValue(e.target.value);
                  } else {
                    setValue(e.target.value);
                  }
                }}
                disabled={disabled}
                readOnly={disableSearch}
                autoComplete="off"
              />
            )}
            {icon && <IconWrapper>{icon}</IconWrapper>}
          </SearchInputWrapper>
        </>
      )}
    </InputContainer>
  );
};

SearchInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  warningMsg: PropTypes.string,
  value: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  showSearchIcon: PropTypes.bool,
  hasError: PropTypes.bool,
  disabled: PropTypes.bool,
  onSearchIconClick: PropTypes.func,
  icon: PropTypes.node,
  component: PropTypes.node,
  viewOnly: PropTypes.bool,
  disableSearch: PropTypes.bool,
  maxLength: PropTypes.number,
  innerRef: PropTypes.object
};

export default SearchInput;
